var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSimpleIllustrationReceiptWrangler = function SvgSimpleIllustrationReceiptWrangler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F2C8AA",
    d: "M17.536 25.728s-.943-.534-1.64-.369c-.695.165-1.351.778-1.311 2.09.04 1.313.451 2.173 1.434 2.13.983-.04 2.017-1.177 2.173-.451.204 4.565 4.52 6.17 7.25 6.268 2.735.097 3.827-1.328 4.428-2.417.601-1.09.739-5.041.205-6.924-.534-1.886-1.6-5.82-1.6-5.82s-6.475-1.473-8.483.123c-2.008 1.596-2.46 5.367-2.46 5.367l.004.003Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF7101",
    d: "M19.421 20.36s-4.016 1.395-5.328 2.99c0 0-.613 2.91-1.599 4.548-.982 1.639-4.672 4.916-4.794 9.301-.04 2.173 2.765 4.54 7.287 4.608 4.523.067 6.14-2.927 6.14-2.927l-.567-4.778-.794-1.181s-.39-.23-1.169-1.868l-.409-1.925M29.01 21.304s2.13 7.049 1.065 10.491l1.98 6.49s4.263 1.167 6.46-.506c0 0 2.622-.778 2.417-4.507-.204-3.729-4.098-5.737-4.467-5.902-.37-.165-5.246-3.277-5.695-3.894-.448-.616-1.76-2.172-1.76-2.172Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D18000",
    d: "M12.62 27.328s1.68-2.5 1.473-3.974c0 0 4.056-2.703 5.328-2.99 0 0-2.868-2.829-6.966-2.869-4.099-.04-5.042 4.22-4.999 5.042.04.82.613 4.138 3.442 4.672.983.204 1.721.122 1.721.122v-.003ZM28.479 20.238s1.76 3.482 3.564 4.343c0 0 3.238-.943 3.564-4.425.327-3.482-2.46-3.402-2.46-3.402s-1.76.122-2.377 1.269c-.613 1.147-1.803 2.212-2.294 2.212l.003.003Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FED607",
    d: "M20.325 8.273s-2.048-2.09-3.973-2.008c-1.926.082-2.869 1.886-2.99 3.85-.123 1.97 1.147 6.803.9 7.459 0 0 2.99 1.147 3.36 1.474.369.326 3.768 2.582 6.966 2.212 3.195-.369 4.999-1.803 4.999-1.803s-.696-1.148-.821-3.934c-.122-2.786-1.187-9.179-4.016-9.753-2.829-.573-3.525 1.557-3.525 1.557l-.9.943v.003Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFAF0",
    d: "M24.42 23.968s.286.409.613.982c.326.574 1.187 1.352 1.187 1.352s1.639-.287 1.721-1.968c.082-1.681-1.843-1.721-1.843-1.721s-1.434.04-1.681 1.352l.003.003ZM22.62 26.524a1.681 1.681 0 1 0 0-3.362 1.681 1.681 0 0 0 0 3.363Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4BC07",
    d: "M19.544 15.868s2.13.04 2.704.656c.573.617 1.351 2.417 1.351 2.417s.04-2.334.861-2.868c.82-.534 2.212-1.27 2.212-1.27s-2.212-.04-2.62-.613c-.41-.574-1.066-1.968-1.27-2.542 0 0-.247 2.13-.696 2.582-.452.451-2.13 1.681-2.542 1.638Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFAF0",
    d: "M23.764 29.802s2.869.083 3.73-.369c0 0-.288 2.008-1.682 2.008-1.395 0-1.886-.37-2.048-1.639Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2C8AA",
    d: "m22.769 34.95 4.647 5.453 1.416-6.11s-1.092 1.191-2.24 1.148c-1.147-.042-3.497-.326-3.823-.491Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0185FF",
    d: "M28.506 38.338s1.037-.275 1.694-.275c.656 0 1.858.22 1.858.22l-1.98-6.491s-.587 2.011-1.517 2.664l-.055 3.879v.003ZM21.13 38.883l3.988-.381-2.35-3.552s-1.803-.711-2.24-1.148l.602 5.081Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.857,
    d: "M12.714 27.272c-3.223.275-5.246-2.13-5.246-4.755 0-2.624 2.13-5.08 5.572-4.97 4.535.164 6.091 4.3 11.761 3.68 6.87-.73 4.904-4.501 8.292-4.501 3.912 0 2.96 6.594-.922 7.793"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.857,
    d: "M29.553 19.484c-.677-1.355-.796-2.914-.873-4.403-.152-2.99-.824-9.786-5.172-9.42-1.828.152-2.1 1.65-3.253 2.706"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.857,
    d: "M22.66 8.969c-1.191.152-2.119-.253-2.955-1.077-.998-.983-1.947-1.828-3.439-1.654-5.19.6-1.913 9.014-1.913 11.419M19.598 20.388s-5.627 1.654-7.308 5.422"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.857,
    d: "M14.045 23.47c-1.056 6.371-5.454 7.464-6.22 12.353-.573 3.933 5.606 9.383 13.306 3.06M26.102 35.387c-6.726.415-7.526-5.37-7.867-6.259-.547-4.666 2.288-7.434 1.367-8.743"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.857,
    d: "M28.561 20.334s5.517 14.482-2.46 15.053M24.044 23.745c.934 1.315 2.65 2.27 2.484 3.417-.165 1.148-2.642.861-2.847.083-.122-.553.635-.513.9-.348"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#002140",
    d: "m26.645 24.428.616-.488a1.145 1.145 0 1 0 .052.864l-.668-.373v-.003ZM23.175 24.782l.616-.488a1.145 1.145 0 1 0 .052.864l-.668-.373v-.003Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.857,
    d: "M23.083 21.971s-1.693-.561-2.307 1.053M24.832 21.685s1.367-.915 2.267.122M28.765 20.144c2.048 6.57 12.17 6.61 12.17 13.72.076 1.816-1.666 6.564-8.88 4.422M23.767 29.885s2.551 0 3.61-.498"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002140",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.857,
    d: "M23.767 29.885s.217 1.837 1.993 1.586c1.12-.186 1.587-1.12 1.617-2.084M27.444 14.76c-3.378.907-3.71 1.334-3.741 4.831-.907-3.378-1.334-3.71-4.83-3.74 3.377-.907 3.71-1.334 3.74-4.832.907 3.379 1.334 3.711 4.831 3.742ZM22.7 34.965l4.64 5.777M28.722 34.475l-1.382 6.268M20.51 33.702l.675 5.197 3.934-.287M28.479 38.283s2.172-.452 3.564.04l-1.926-6.229"
  })));
};
export default SvgSimpleIllustrationReceiptWrangler;